module.exports = __webpack_public_path__ + "fonts/Arial Narrow Bold.45d4540c.ttf";